import api from "../../index";

export const GetAllSymbolApi = (params) => api.get(`Admin/Get-Group-Detail?${params}`);
export const UpdateUserStatusApi = (data) => api.post('Admin/Update-Symbol-Detail', data);
export const GetAllSymbolDetailApi = (params) => api.get(`Admin/Get-Symbol-Detail?${params}`);
